(function ($, bootstrap) {

$(document).ready(function(){
 
  $( '.show-descr' ).on( 'click', function(){
    $('.text').slideUp();
    $(this).parent().children('.text').slideDown();
  });

  $( '.hidden-descr' ).on( 'click', function(){
    $('.text').parent().children('.text').slideUp();
  });

  $('.search-button').on( 'click', function(){
    $('.searchbox').slideToggle('fast');
  });

  // Bootstrap MENU
  $('.dropdown-toggle').dropdown();



  $('.shop-floor').on('click',function() {
   
    $floorSelect = $(this).data('map');

    if ($floorSelect){

      $('.mapplic-layer').hide();
      $('.shop-floor').removeClass('text-bold');
      $('.mapplic-layer[data-floor="'+ $floorSelect +'"]').fadeIn('fast');
      $( this ).addClass('text-bold');
    } 

  });



});

})(jQuery, Bootstrap);


//////////////////
// WEBPACK FOOTER
// ../src/js/components/nav.js
// module id = 0
// module chunks = 2